import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
  class: "dept-tag-name"
};
import { computed } from 'vue';
import { useFormSize } from 'element-plus';
export default {
  __name: 'DeptTag',
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const formSize = useFormSize();
    const sizeClass = computed(() => {
      const s = formSize.value || 'default';
      if (s === 'small') return 'is-small';
      if (s === 'large') return 'is-large';
      return 'is-default';
    });
    const displayName = computed(() => props.name || String(props.id));
    const onClose = () => {
      emit('close', props.id);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["dept-tag", [sizeClass.value, {
          'is-disabled': __props.disabled
        }]]),
        title: displayName.value
      }, [_cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "dept-tag-icon",
        "aria-hidden": "true"
      }, [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M3 21h18M5 21V7a2 2 0 012-2h10a2 2 0 012 2v14M9 9h1m4 0h1M9 13h1m4 0h1M10 21v-4a1 1 0 011-1h2a1 1 0 011 1v4"
      })])], -1)), _createElementVNode("span", _hoisted_2, _toDisplayString(displayName.value), 1), __props.closable && !__props.disabled ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "dept-tag-close",
        "aria-label": "移除",
        onClick: _withModifiers(onClose, ["stop"])
      }, [...(_cache[0] || (_cache[0] = [_createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2.5",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])) : _createCommentVNode("", true)], 10, _hoisted_1);
    };
  }
};